import { Button, Input, Modal, Spin, Typography } from "antd";
import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import { ADD_FLIGHT_MODEL_INITIAL_OBJECT } from "./FlightModelManagementUtils";
import { StatusManagementAPI } from "../../../API/admin/StatusManagementAPI";
import { FlightModalAPI } from "../../../API/FlightModalAPI";
const { Text } = Typography;

export const AddNewFlight = ({
  open,
  setOpen,
  messageToast,
  loadConfigData,
}) => {
  const [inputElements, setInputElements] = useState(
    ADD_FLIGHT_MODEL_INITIAL_OBJECT,
  );
  const [loadSpin, setLoadSpin] = useState(false);

  function addFun() {
    if (inputElements.name.trim() !== "") {
      if (inputElements.name.trim().length < 100) {
        setLoadSpin(true);
        const bodyData = {
          flight_model: inputElements.name,
        };
        addFlightModelFun(bodyData);
      }
    } else {
      setInputElements((prev) => ({
        ...prev,
        errorFieds: {
          name: "Name is required",
        },
      }));
    }
  }

  function backFun() {
    setInputElements(ADD_FLIGHT_MODEL_INITIAL_OBJECT);
    setOpen(false);
  }

  async function addFlightModelFun(bodyData) {
    await FlightModalAPI.addFlightModel(bodyData)
      .then((res) => {
        if (res.data.status === true) {
          setOpen(false);
          setLoadSpin(false);
          setInputElements(ADD_FLIGHT_MODEL_INITIAL_OBJECT);
          window.location.reload();
          loadConfigData();
        } else {
          messageToast("error", res.data?.message);
          setLoadSpin(false);
        }
      })
      .catch(() => {
        messageToast("error", "Internal Server Error");
        setLoadSpin(false);
      });
  }

  return (
    <Modal
      open={open}
      okText="Apply"
      cancelText="Clear All"
      onCancel={() => backFun()}
      onOk={addFun}
      footer={[
        <Button key="back" type="text" onClick={backFun}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={addFun}>
          Add
        </Button>,
      ]}
    >
      <Spin spinning={loadSpin}>
        <div style={{ padding: "10px" }}>
          <div
            style={{
              marginBottom: "20px",
              borderBottom: "solid 1px #80808047",
            }}
          >
            <Title level={5}>Add Flight Model</Title>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label>Name</label>
            <Input
              status={!inputElements.errorFieds.name ? "" : "error"}
              value={inputElements.name}
              onChange={(e) => {
                const value = e.target.value.trimStart();
                let error = "";

                if (value.trim() === "") {
                  error = "Name is required";
                } else if (value.trim().length >= 100) {
                  error = "MAX length 100!";
                }

                setInputElements((prev) => ({
                  ...prev,
                  name: value,
                  errorFieds: {
                    name: error,
                  },
                }));
              }}
            />
            <Text type="danger" italic>
              {inputElements.errorFieds.name}
            </Text>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};
